import {
  OrderFulfillmentType,
  OrderPaymentType,
} from "@sellar-io/api-v2/types";

export type OrderPaymentMethodProps = {
  method: string;
};

export type generateOrderPaymentMethodTextProps = {
  credit?: boolean;
  fulfillmentType: OrderFulfillmentType;
  paymentType: OrderPaymentType | null;
  paid: boolean;
  paymentTerms?: "credit" | "proforma" | "paymentOnDelivery" | null;
  orderPrice: number;
  hasPaymentLink: boolean;
  hasPaymentLinkPayment: boolean;
};

export const generateOrderPaymentMethodText = ({
  fulfillmentType,
  paymentType,
  paid,
  paymentTerms,
  orderPrice,
  hasPaymentLink,
  hasPaymentLinkPayment,
}: generateOrderPaymentMethodTextProps): string => {
  if (orderPrice === 0) return "n/a";
  switch (paymentType) {
    case "manual": {
      if (paid) {
        return hasPaymentLink && hasPaymentLinkPayment
          ? "Paid by card"
          : "Paid offline";
      }
      if (hasPaymentLink) {
        return "Card payment link";
      }
      return paymentTerms === "paymentOnDelivery"
        ? "Payment on delivery"
        : "Arrange payment outside of Sellar";
    }
    case "stripe": {
      if (paid) {
        return "Paid via card";
      }
      if (fulfillmentType === "collection") {
        return "Payment after collection";
      }
      return "Pay via card";
    }
    case "checkout":
      if (paid) {
        return "Paid via card";
      }
      return "Card";
    case "sellarCredit":
      return "Sellar Credit";
    case "cardPaymentWithDeposit":
      if (paid) {
        return "Paid via card";
      }
      return "Card deposit";
    default:
      return "";
  }
};
